import React from 'react';
import { Tag, Typography, message } from 'antd';
import { formatDate } from './dateUtils';

const { Text } = Typography;

export const createCandidateListColumns = (history) => [
  {
    title: 'Candidate',
    key: 'candidate',
    width: 250,
    render: (_, record) => (
      <div style={{ paddingLeft: '16px', wordWrap: 'break-word', whiteSpace: 'normal' }}>
        <a
          href={`/candidates/${record.id}`}
          onClick={(e) => {
            e.preventDefault();
            if (history) {
              history.push(`/candidates/${record.id}`);
            }
          }}
          style={{ 
            fontSize: '14px', 
            fontWeight: 'bold', 
            color: '#1890ff', 
            textDecoration: 'none',
            wordWrap: 'break-word',
            whiteSpace: 'normal'
          }}
        >
          {`${record.firstName} ${record.lastName}`}
        </a>
      </div>
    ),
    sorter: (a, b) => `${a.firstName} ${a.lastName}`.localeCompare(`${b.firstName} ${b.lastName}`),
  },
  {
    title: 'Email',
    key: 'email',
    width: 350,
    render: (_, record) => {
      const primaryEmail = record.emailAddresses && record.emailAddresses.length > 0 
        ? record.emailAddresses[0] 
        : null;
        
      if (!primaryEmail) {
        return (
          <Text style={{ fontSize: '13px', color: '#666' }}>
            No email
          </Text>
        );
      }
      
      const handleCopyEmail = async () => {
        try {
          await navigator.clipboard.writeText(primaryEmail);
          message.success('Email copied!');
        } catch (err) {
          message.error('Failed to copy email');
        }
      };
      
      return (
        <Text 
          style={{ 
            fontSize: '13px', 
            color: '#666',
            cursor: 'pointer'
          }}
          onClick={handleCopyEmail}
          title="Click to copy email"
        >
          {primaryEmail}
        </Text>
      );
    },
  },
  {
    title: 'ATS ID',
    key: 'atsIds',
    width: 120,
    render: (_, record) => {
      const atsIds = record.atsIds || [];
      const validAtsIds = atsIds.filter(id => id !== null && id !== undefined && id !== '');
      
      if (validAtsIds.length === 0) {
        return (
          <Text style={{ 
            fontSize: '13px', 
            color: '#666',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            display: 'block'
          }}>
            -
          </Text>
        );
      }
      
      const atsIdText = validAtsIds.join(', ');
      
      const handleCopyAtsId = async () => {
        try {
          await navigator.clipboard.writeText(atsIdText);
          message.success('ATS ID copied!');
        } catch (err) {
          message.error('Failed to copy ATS ID');
        }
      };
      
      return (
        <Text 
          style={{ 
            fontSize: '13px', 
            color: '#666',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            display: 'block',
            cursor: 'pointer'
          }}
          onClick={handleCopyAtsId}
          title="Click to copy ATS ID"
        >
          {atsIdText}
        </Text>
      );
    },
  },
  {
    title: 'Applications',
    key: 'applications',
    align: 'center',
    render: (_, record) => {
      const appCount = record.applicationCount || 0;
      return (
        <Tag color={appCount > 0 ? 'blue' : 'default'}>
          {appCount}
        </Tag>
      );
    },
    sorter: (a, b) => (a.applicationCount || 0) - (b.applicationCount || 0),
  },
  {
    title: 'Referrals',
    key: 'referrals',
    align: 'center',
    render: (_, record) => {
      const refCount = record.referralCount || 0;
      return (
        <Tag color={refCount > 0 ? 'green' : 'default'}>
          {refCount}
        </Tag>
      );
    },
    sorter: (a, b) => (a.referralCount || 0) - (b.referralCount || 0),
  },
  {
    title: 'Active Referrer',
    key: 'owner',
    render: (_, record) => {
      const owner = record.owner;
      if (!owner) {
        return <Text style={{ fontSize: '14px' }}>-</Text>;
      }

      const ownerName = `${owner.firstName} ${owner.lastName}`;

      if (owner.id) {
        return (
          <a
            href={`/employees/${owner.id}`}
            onClick={(e) => {
              e.preventDefault();
              if (history) {
                history.push(`/employees/${owner.id}`);
              }
            }}
            style={{
              fontSize: '14px',
              color: '#1890ff',
              textDecoration: 'none'
            }}
          >
            {ownerName}
          </a>
        );
      }

      return (
        <Text style={{ fontSize: '14px' }}>
          {ownerName}
        </Text>
      );
    },
  },
  {
    title: 'Active Referrer End',
    key: 'ownershipEnds',
    render: (_, record) => (
      <Text style={{ fontSize: '14px' }}>
        {formatDate(record.ownershipEndDate)}
      </Text>
    ),
    sorter: (a, b) => new Date(a.ownershipEndDate || 0) - new Date(b.ownershipEndDate || 0),
  },
];

export const tableComponents = {
  header: {
    cell: (props) => (
      <th {...props} style={{ 
        ...props.style, 
        paddingLeft: '16px'
      }} />
    )
  },
  body: {
    cell: (props) => (
      <td {...props} style={{ 
        ...props.style, 
        paddingLeft: '16px'
      }} />
    )
  }
};